import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { graphql } from 'react-apollo';
import { queryNotifications } from './myNotificationsQuery';
import { notificationCreatedSubscription } from './notificationCreatedSubscription';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faBell from '@fortawesome/fontawesome-pro-light/faBell';

const withData = graphql(queryNotifications, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
  props: props => {
    return {
      subscribeToNewNotifications: currentProps => {
        return props.data.subscribeToMore({
          document: notificationCreatedSubscription,
          variables: {},
          updateQuery: (prev, { subscriptionData }) => {
            if (!subscriptionData.data) {
              return prev;
            }

            const newNotification = subscriptionData.data.notificationCreated;
            const x = [...prev.myNotifications];

            x.unshift(newNotification);

            return { ...prev, myNotifications: x };
          },
        });
      },
      ...props,
    };
  },
});

@withData
class NotificationsButton extends React.Component {
  static propTypes = {
    projectId: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
    data: PropTypes.object,
    subscribeToNewNotifications: PropTypes.func,
  };

  componentWillMount() {
    const { subscribeToNewNotifications } = this.props;
    this.subscription = subscribeToNewNotifications(this.props);
  }

  componentWillUnmount() {
    this.subscription();
  }

  render() {
    const {
      data: { myNotifications },
    } = this.props;
    // if (loading) return <div />;

    return (
      <Link
        to="/notifications"
        className="notifcations"
        style={{ position: 'relative' }}
      >
        <FontAwesomeIcon
          size="lg"
          icon={faBell}
          color="#0e4151"
          className="fa-style"
        />
        {myNotifications && (
          <span
            style={{
              position: 'absolute',
              // top: 4,
              right: 4,
              borderRadius: '.25rem',
              padding: 2,
            }}
            className="badge badge-danger"
          >
            {myNotifications.length}
          </span>
        )}
      </Link>
    );
  }
}

export default NotificationsButton;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/NotificationIcon/NotificationIcon.js